// Firebase web config. Every value here is compiled into the public JS
// bundle, so it may contain ONLY values that are public by design
// (apiKey, authDomain, projectId, storageBucket, messagingSenderId, appId,
// measurementId — Firebase treats these as identifiers, not credentials).
//
// TNMC-222: serviceAccountId, credential, hubspotApiBearerToken and secret
// used to live here. Nothing in src/ ever read them, and they shipped to
// every browser. The Cloud Functions read those from process.env instead
// (functions/.env), which is where they belong. Do not reintroduce them.
export const firebaseConfig= {
    "apiKey": "AIzaSyBoQLkPRwvixSHbMPGx6r4scNIz88H-tvg",
    "authDomain": "truenorth-production.firebaseapp.com",
    "projectId": "truenorth-production",
    "storageBucket": "truenorth-production.firebasestorage.app",
    "messagingSenderId": "11182580643",
    "appId": "1:11182580643:web:ff3606034e74b5e9dff016",
    "measurementId": "G-3XEKCNYZBL"
};
